import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import IncidentTrackerDialogForm from './components/IncidentTrackerDialogForm';
import {
	SetFormState, ResetFields, GetIncidentDetails, GetIncidentDropdowns,
	EditIncidentDetails, CreateIncident,
	ToggleIncidentTrackerDialog
} from '../../../actions/IncidentTrackerActions';

const IncidentTrackerDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.incidentTrackerDemoReducer.tableId);
	const selectedDates = useSelector((state) => state.incidentTrackerDemoReducer.selectedDates);
	const selectedFailures = useSelector((state) => state.incidentTrackerDemoReducer.selectedFailures);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.incidentTrackerDemoReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const title = tableId ? 'Edit Ticket' : 'Create Ticket';
	const confirmLabel = tableId ? 'Save' : 'Create';

	const _onConfirmClick = () => {
		setFormState({ ...formState, values: { ...formState.values, submit: true } });

		if (formState.isValid) {
			const object = { ...formState.values, userId, selectedDates, selectedFailures };
			if (tableId) {
				dispatch(EditIncidentDetails(object));
				dispatch(ToggleIncidentTrackerDialog(false));
				dispatch(enqueueSnackbar({ message: 'Ticket details saved', options: { variant: 'info' } }));
			} else {
				dispatch(CreateIncident(object));
				dispatch(ToggleIncidentTrackerDialog(false));
				dispatch(enqueueSnackbar({ message: 'Ticket created', options: { variant: 'info' } }));
			}
		}
	};

	const getData = useCallback(() => {
		dispatch(GetIncidentDropdowns());
	}, []);

	useEffect(() => {
		getData();
		if (tableId) {
			dispatch(GetIncidentDetails(userId, tableId));
			dispatch(ResetFields());
		}
	}, [tableId]);

	return (
		<ModalDialog
			maxWidth="xl"
			onClose={onClose}
			open={open}
			title={title}
			confirmLabel={confirmLabel}
			onConfirmClicked={_onConfirmClick}
			hasConfirm={!formState.values.disableModalSaveButton}
			cancelLabel={!formState.values.disableModalSaveButton ? 'Cancel' : 'Close'}
		>
			<IncidentTrackerDialogForm tableId={tableId} />
		</ModalDialog>
	);
};

IncidentTrackerDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default IncidentTrackerDialog;
